(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-product"]) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form.editorial-form');
    if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-editorial-variants]').textContent);
    const input = form.elements.quantity;
    const status = root.querySelector('[data-editorial-status]');
    const buyButtons = [...root.querySelectorAll('[data-editorial-buy]')];
    let busy = false;
    const current = () => variants.find(v => String(v.id) === form.elements.id.value) || variants[0];
    function update() {
      const variant = current();
      input.min = variant.min; input.step = variant.step;
      if (variant.max) input.max = variant.max; else input.removeAttribute('max');
      root.querySelectorAll('[data-editorial-price]').forEach(el => { el.textContent = variant.formatted; });
      const compare = root.querySelector('[data-editorial-compare]');
      compare.hidden = variant.compare <= variant.price;
      compare.textContent = variant.compareFormatted;
      buyButtons.forEach(button => {
        button.disabled = busy || !variant.available;
        button.textContent = busy ? root.dataset.addingLabel : !variant.available ? root.dataset.soldLabel : root.dataset.addLabel + (button.hasAttribute('data-editorial-compact') ? '' : ' — ' + variant.money);
      });
    }
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-editorial-thumb]');
      if (thumb) {
        root.querySelectorAll('[data-editorial-slide]').forEach(slide => { slide.hidden = slide.dataset.editorialSlide !== thumb.dataset.editorialThumb; if (slide.hidden) slide.querySelector('video')?.pause(); });
        root.querySelectorAll('[data-editorial-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }
      const quantity = event.target.closest('[data-editorial-qty]');
      if (quantity) {
        const next = Number(input.value || input.min) + Number(quantity.dataset.editorialQty) * Number(input.step);
        input.value = String(Math.max(Number(input.min), Math.min(input.max ? Number(input.max) : Infinity, next)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const tab = event.target.closest('[data-editorial-tab]');
      if (tab) activateTab(tab);
    });
    function activateTab(tab) {
      root.querySelectorAll('[data-editorial-tab]').forEach(button => { button.setAttribute('aria-selected', String(button === tab)); button.tabIndex = button === tab ? 0 : -1; });
      root.querySelectorAll('[data-editorial-panel]').forEach(panel => { panel.hidden = panel.dataset.editorialPanel !== tab.dataset.editorialTab; });
    }
    root.querySelector('.editorial-tabs')?.addEventListener('keydown', event => {
      const tabs = [...root.querySelectorAll('[data-editorial-tab]')];
      const index = tabs.indexOf(event.target);
      if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      activateTab(tabs[next]); tabs[next].focus();
    });
    form.elements.id.addEventListener('change', () => { update(); const url = new URL(location.href); url.searchParams.set('variant', form.elements.id.value); history.replaceState({}, '', url); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity() || !current().available) return;
      busy = true; status.textContent = ''; update();
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || root.dataset.errorLabel);
        status.textContent = root.dataset.addedLabel;
        root.querySelector('[data-editorial-cart-link]').hidden = false;
        window.location.assign(root.dataset.cartUrl);
      } catch (error) { status.textContent = error.message || root.dataset.errorLabel; }
      finally { busy = false; update(); }
    });
    const primary = root.querySelector('[data-editorial-primary]');
    const sticky = root.querySelector('[data-editorial-sticky]');
    let primaryVisible = true;
    const syncSticky = () => {
      const menuOpen = document.querySelector('[data-menu-toggle]')?.getAttribute('aria-expanded') === 'true';
      sticky.hidden = primaryVisible || menuOpen;
    };
    const observer = new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; syncSticky(); }, { threshold: 0.1 });
    observer.observe(primary);
    const menu = document.querySelector('[data-menu-toggle]');
    const menuObserver = new MutationObserver(syncSticky);
    if (menu) menuObserver.observe(menu, { attributes: true, attributeFilter: ['aria-expanded'] });
    document.addEventListener('shopify:section:unload', event => { if (event.detail.sectionId === root.dataset.sectionId) { observer.disconnect(); menuObserver.disconnect(); } });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const videos = [...root.querySelectorAll('.editorial-video')];
    const videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting && !reduced.matches) entry.target.play().catch(() => {});
      else entry.target.pause();
    }), { threshold: 0.3 });
    videos.forEach(video => videoObserver.observe(video));
    const onMotion = () => { if (reduced.matches) videos.forEach(video => video.pause()); };
    reduced.addEventListener('change', onMotion);
    document.addEventListener('shopify:section:unload', event => {
      if (event.detail.sectionId === root.dataset.sectionId) { videoObserver.disconnect(); reduced.removeEventListener('change', onMotion); }
    });
    root.querySelectorAll('.editorial-details details').forEach(detail => detail.addEventListener('toggle', () => {
      if (detail.open) root.querySelectorAll('.editorial-details details').forEach(other => { if (other !== detail) other.open = false; });
    }));
    update();
  }
  document.querySelectorAll('[data-editorial-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-editorial-root]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gspa-product"]) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form.gspa-form');
    if (!form) return;
    const variants = JSON.parse(root.querySelector('[data-gspa-variants]').textContent);
    const input = form.elements.quantity;
    const status = root.querySelector('[data-gspa-status]');
    const buyButtons = [...root.querySelectorAll('[data-gspa-buy]')];
    let busy = false;
    const current = () => variants.find(v => String(v.id) === form.elements.id.value) || variants[0];
    function update() {
      const variant = current();
      input.min = variant.min; input.step = variant.step;
      if (variant.max) input.max = variant.max; else input.removeAttribute('max');
      root.querySelectorAll('[data-gspa-price]').forEach(el => { el.textContent = variant.formatted; });
      const compare = root.querySelector('[data-gspa-compare]');
      compare.hidden = variant.compare <= variant.price;
      compare.textContent = variant.compareFormatted;
      buyButtons.forEach(button => {
        button.disabled = busy || !variant.available;
        button.textContent = busy ? root.dataset.addingLabel : !variant.available ? root.dataset.soldLabel : root.dataset.addLabel + (button.hasAttribute('data-gspa-compact') ? '' : ' — ' + variant.money);
      });
    }
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gspa-thumb]');
      if (thumb) {
        root.querySelectorAll('[data-gspa-slide]').forEach(slide => { slide.hidden = slide.dataset.gspaSlide !== thumb.dataset.gspaThumb; if (slide.hidden) slide.querySelector('video')?.pause(); });
        root.querySelectorAll('[data-gspa-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }
      const quantity = event.target.closest('[data-gspa-qty]');
      if (quantity) {
        const next = Number(input.value || input.min) + Number(quantity.dataset.gspaQty) * Number(input.step);
        input.value = String(Math.max(Number(input.min), Math.min(input.max ? Number(input.max) : Infinity, next)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const tab = event.target.closest('[data-gspa-tab]');
      if (tab) activateTab(tab);
    });
    function activateTab(tab) {
      root.querySelectorAll('[data-gspa-tab]').forEach(button => { button.setAttribute('aria-selected', String(button === tab)); button.tabIndex = button === tab ? 0 : -1; });
      root.querySelectorAll('[data-gspa-panel]').forEach(panel => { panel.hidden = panel.dataset.gspaPanel !== tab.dataset.gspaTab; });
    }
    root.querySelector('.gspa-tabs')?.addEventListener('keydown', event => {
      const tabs = [...root.querySelectorAll('[data-gspa-tab]')];
      const index = tabs.indexOf(event.target);
      if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      activateTab(tabs[next]); tabs[next].focus();
    });
    form.elements.id.addEventListener('change', () => { update(); const url = new URL(location.href); url.searchParams.set('variant', form.elements.id.value); history.replaceState({}, '', url); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !form.reportValidity() || !current().available) return;
      busy = true; status.textContent = ''; update();
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || root.dataset.errorLabel);
        status.textContent = root.dataset.addedLabel;
        root.querySelector('[data-gspa-cart-link]').hidden = false;
        window.location.assign(root.dataset.cartUrl);
      } catch (error) { status.textContent = error.message || root.dataset.errorLabel; }
      finally { busy = false; update(); }
    });
    const primary = root.querySelector('[data-gspa-primary]');
    const sticky = root.querySelector('[data-gspa-sticky]');
    let primaryVisible = true;
    const syncSticky = () => {
      const menuOpen = document.querySelector('[data-menu-toggle]')?.getAttribute('aria-expanded') === 'true';
      sticky.hidden = primaryVisible || menuOpen;
    };
    const observer = new IntersectionObserver(([entry]) => { primaryVisible = entry.isIntersecting; syncSticky(); }, { threshold: 0.1 });
    observer.observe(primary);
    const menu = document.querySelector('[data-menu-toggle]');
    const menuObserver = new MutationObserver(syncSticky);
    if (menu) menuObserver.observe(menu, { attributes: true, attributeFilter: ['aria-expanded'] });
    document.addEventListener('shopify:section:unload', event => { if (event.detail.sectionId === root.dataset.sectionId) { observer.disconnect(); menuObserver.disconnect(); } });
    update();
  }
  document.querySelectorAll('[data-gspa-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-gspa-root]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-hub-journal"] && !Shopify.designMode) return;
  try {
    
  const initWellnessJournal = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const cards = [...root.querySelectorAll('[data-wellness-story]')];
    const button = root.querySelector('[data-wellness-more]');
    if (cards.length <= 6) return;
    cards.slice(6).forEach(card => { card.hidden = true; });
    button.hidden = false;
    button.addEventListener('click', () => {
      cards.forEach(card => { card.hidden = false; });
      button.hidden = true;
      cards[6].focus();
    });
  };
  document.querySelectorAll('[data-wellness-journal]').forEach(initWellnessJournal);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wellness-journal]').forEach(initWellnessJournal));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-hub-quiz"] && !Shopify.designMode) return;
  try {
    
  const initWellnessHub = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-ls-quiz-config]').textContent);
    const content = root.querySelector('[data-ls-quiz-content]');
    const progress = root.querySelector('[data-ls-quiz-progress]');
    const labels = root.dataset;
    const scores = [
      [[3,1,0,0,0],[1,3,0,0,0],[0,0,3,1,0],[0,0,0,2,2]],
      [[2,2,0,0,0],[1,3,0,0,0],[0,0,3,1,0],[0,0,0,3,1]],
      [[3,1,0,0,0],[0,3,0,0,0],[0,0,2,1,1],[0,0,0,0,3]],
      [[3,1,0,0,0],[1,3,0,0,0],[0,0,2,1,1],[0,0,0,2,2]],
      [[3,1,0,0,0],[0,3,0,0,0],[0,0,3,1,0],[0,0,0,1,3]]
    ];
    let current = 0;
    let answers = [];
    let profileIndex = 0;

    const escapeHtml = (value) => {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    };

    const renderProgress = (complete = false) => {
      progress.innerHTML = config.questions.map((question, index) => `<span class="ls-wellness-hub__dot${complete || index === current ? ' is-active' : ''}"></span>`).join('');
    };

    const calculateProfile = () => {
      const totals = [0, 0, 0, 0, 0];
      answers.forEach((answer, questionIndex) => {
        scores[questionIndex][answer].forEach((score, index) => { totals[index] += score; });
      });
      let best = 0;
      totals.forEach((score, index) => {
        if (score > totals[best]) best = index;
      });
      return best;
    };

    const renderQuestion = () => {
      renderProgress();
      const question = config.questions[current];
      const selected = answers[current];
      const options = question.options.map((option, index) => `<button type="button" class="ls-wellness-hub__option${selected === index ? ' is-selected' : ''}" data-option="${index}">${escapeHtml(option)}</button>`).join('');
      content.innerHTML = `<h3 class="ls-wellness-hub__question">${escapeHtml(question.question)}</h3><div class="ls-wellness-hub__options">${options}</div><div class="ls-wellness-hub__nav"><button type="button" class="ls-button" data-next ${selected === undefined ? 'disabled' : ''}>${current < config.questions.length - 1 ? escapeHtml(labels.continueLabel) : escapeHtml(labels.resultLabel)}</button></div>`;
      content.querySelectorAll('[data-option]').forEach((button) => {
        button.addEventListener('click', () => {
          answers[current] = Number(button.dataset.option);
          renderQuestion();
        });
      });
      content.querySelector('[data-next]').addEventListener('click', () => {
        if (answers[current] === undefined) return;
        if (current < config.questions.length - 1) {
          current += 1;
          renderQuestion();
        } else {
          renderResult();
        }
      });
    };

    const sendToKlaviyo = (name, email, profile) => {
      const query = `?company_id=${encodeURIComponent(labels.companyId)}`;
      const headers = { 'Content-Type': 'application/json', revision: '2024-02-15' };
      return fetch(`https://a.klaviyo.com/client/profiles/${query}`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ data: { type: 'profile', attributes: { email, first_name: name || '', properties: {
          quiz_result: profile.result,
          quiz_profile: profile.id,
          recommended_product_name: profile.productName,
          recommended_product_url: profile.productUrl,
          recommendation_category: profile.category,
          confidence_level: profile.confidence,
          quiz_collection: profile.collection,
          quiz_completed_at: new Date().toISOString()
        } } } })
      }).then((response) => {
        if (!response.ok) throw new Error(`Profile API ${response.status}`);
        return fetch(`https://a.klaviyo.com/client/subscriptions/${query}`, {
          method: 'POST',
          headers,
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Wellness Quiz', profile: { data: { type: 'profile', attributes: { email, first_name: name || '' } } } }, relationships: { list: { data: { type: 'list', id: labels.listId } } } } })
        });
      }).then((response) => {
        if (!response.ok) throw new Error(`Subscription API ${response.status}`);
      });
    };

    const renderThankYou = (name, profile) => {
      progress.hidden = true;
      const title = name ? `${escapeHtml(root.dataset.thankYouName)}, ${escapeHtml(name)}.` : escapeHtml(root.dataset.thankYou);
      content.innerHTML = `<div class="ls-wellness-hub__thanks"><div class="ls-wellness-hub__thanks-icon">◇</div><h3 class="ls-wellness-hub__result-title">${title}</h3><p class="ls-wellness-hub__result-copy">${escapeHtml(root.dataset.checkInbox)}</p><p class="ls-wellness-hub__fine-print">${escapeHtml(root.dataset.matchedTo)} ${escapeHtml(profile.title)}</p></div>`;
    };

    const renderResult = () => {
      profileIndex = calculateProfile();
      const profile = config.results[profileIndex];
      renderProgress(true);
      content.innerHTML = `<div class="ls-wellness-hub__result"><p class="ls-eyebrow">${escapeHtml(profile.eyebrow)}</p><h3 class="ls-wellness-hub__result-title">${escapeHtml(profile.title)}</h3><p class="ls-wellness-hub__result-copy">${escapeHtml(profile.profile)}</p><div class="ls-wellness-hub__capture"><h3>${escapeHtml(root.dataset.captureHeading)}</h3><p>${escapeHtml(root.dataset.captureCopy)}</p><div class="ls-wellness-hub__form"><label class="ls-visually-hidden" for="QuizName-${root.id}">${escapeHtml(root.dataset.nameLabel)}</label><input id="QuizName-${root.id}" type="text" autocomplete="given-name" placeholder="${escapeHtml(root.dataset.namePlaceholder)}"><label class="ls-visually-hidden" for="QuizEmail-${root.id}">${escapeHtml(root.dataset.emailLabel)}</label><input id="QuizEmail-${root.id}" type="email" autocomplete="email" placeholder="${escapeHtml(root.dataset.emailPlaceholder)}" required><button type="button" class="ls-button" data-submit>${escapeHtml(labels.submitLabel)}</button><p class="ls-wellness-hub__error" data-error>${escapeHtml(root.dataset.error)}</p></div><p class="ls-wellness-hub__fine-print">${escapeHtml(root.dataset.finePrint)}</p></div><a class="ls-wellness-hub__browse" href="/collections/all">${escapeHtml(root.dataset.browse)}</a></div>`;
      content.querySelector('[data-submit]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const name = content.querySelector('input[type="text"]').value.trim();
        const emailInput = content.querySelector('input[type="email"]');
        const email = emailInput.value.trim();
        const error = content.querySelector('[data-error]');
        if (!emailInput.checkValidity()) {
          emailInput.reportValidity();
          return;
        }
        button.disabled = true;
        button.textContent = labels.sendingLabel;
        error.style.display = 'none';
        try {
          await sendToKlaviyo(name, email, profile);
          renderThankYou(name, profile);
        } catch (requestError) {
          button.disabled = false;
          button.textContent = labels.submitLabel;
          error.style.display = 'block';
        }
      });
    };

    root.querySelector('[data-ls-quiz-start]').addEventListener('click', (event) => {
      event.preventDefault();
      root.querySelector('.ls-wellness-hub__card').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    renderQuestion();
  };

  const initAllWellnessHubzes = () => document.querySelectorAll('[data-ls-wellness-hub]').forEach(initWellnessHub);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllWellnessHubzes);
  else initAllWellnessHubzes();
  document.addEventListener('shopify:section:load', initAllWellnessHubzes);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-quiz"] && !Shopify.designMode) return;
  try {
    
  const initWellnessQuiz = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-ls-quiz-config]').textContent);
    const content = root.querySelector('[data-ls-quiz-content]');
    const progress = root.querySelector('[data-ls-quiz-progress]');
    const labels = root.dataset;
    const scores = [
      [[3,1,0,0,0],[1,3,0,0,0],[0,0,3,1,0],[0,0,0,2,2]],
      [[2,2,0,0,0],[1,3,0,0,0],[0,0,3,1,0],[0,0,0,3,1]],
      [[3,1,0,0,0],[0,3,0,0,0],[0,0,2,1,1],[0,0,0,0,3]],
      [[3,1,0,0,0],[1,3,0,0,0],[0,0,2,1,1],[0,0,0,2,2]],
      [[3,1,0,0,0],[0,3,0,0,0],[0,0,3,1,0],[0,0,0,1,3]]
    ];
    let current = 0;
    let answers = [];
    let profileIndex = 0;

    const escapeHtml = (value) => {
      const element = document.createElement('div');
      element.textContent = value || '';
      return element.innerHTML;
    };

    const renderProgress = (complete = false) => {
      progress.innerHTML = config.questions.map((question, index) => `<span class="ls-wellness-quiz__dot${complete || index === current ? ' is-active' : ''}"></span>`).join('');
    };

    const calculateProfile = () => {
      const totals = [0, 0, 0, 0, 0];
      answers.forEach((answer, questionIndex) => {
        scores[questionIndex][answer].forEach((score, index) => { totals[index] += score; });
      });
      let best = 0;
      totals.forEach((score, index) => {
        if (score > totals[best]) best = index;
      });
      return best;
    };

    const renderQuestion = () => {
      renderProgress();
      const question = config.questions[current];
      const selected = answers[current];
      const options = question.options.map((option, index) => `<button type="button" class="ls-wellness-quiz__option${selected === index ? ' is-selected' : ''}" data-option="${index}">${escapeHtml(option)}</button>`).join('');
      content.innerHTML = `<h3 class="ls-wellness-quiz__question">${escapeHtml(question.question)}</h3><div class="ls-wellness-quiz__options">${options}</div><div class="ls-wellness-quiz__nav"><button type="button" class="ls-button" data-next ${selected === undefined ? 'disabled' : ''}>${current < config.questions.length - 1 ? escapeHtml(labels.continueLabel) : escapeHtml(labels.resultLabel)}</button></div>`;
      content.querySelectorAll('[data-option]').forEach((button) => {
        button.addEventListener('click', () => {
          answers[current] = Number(button.dataset.option);
          renderQuestion();
        });
      });
      content.querySelector('[data-next]').addEventListener('click', () => {
        if (answers[current] === undefined) return;
        if (current < config.questions.length - 1) {
          current += 1;
          renderQuestion();
        } else {
          renderResult();
        }
      });
    };

    const sendToKlaviyo = (name, email, profile) => {
      const query = `?company_id=${encodeURIComponent(labels.companyId)}`;
      const headers = { 'Content-Type': 'application/json', revision: '2024-02-15' };
      return fetch(`https://a.klaviyo.com/client/profiles/${query}`, {
        method: 'POST',
        headers,
        body: JSON.stringify({ data: { type: 'profile', attributes: { email, first_name: name || '', properties: {
          quiz_result: profile.result,
          quiz_profile: profile.id,
          recommended_product_name: profile.productName,
          recommended_product_url: profile.productUrl,
          recommendation_category: profile.category,
          confidence_level: profile.confidence,
          quiz_collection: profile.collection,
          quiz_completed_at: new Date().toISOString()
        } } } })
      }).then((response) => {
        if (!response.ok) throw new Error(`Profile API ${response.status}`);
        return fetch(`https://a.klaviyo.com/client/subscriptions/${query}`, {
          method: 'POST',
          headers,
          body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Wellness Quiz', profile: { data: { type: 'profile', attributes: { email, first_name: name || '' } } } }, relationships: { list: { data: { type: 'list', id: labels.listId } } } } })
        });
      }).then((response) => {
        if (!response.ok) throw new Error(`Subscription API ${response.status}`);
      });
    };

    const renderThankYou = (name, profile) => {
      progress.hidden = true;
      const title = name ? `${escapeHtml(root.dataset.thankYouName)}, ${escapeHtml(name)}.` : escapeHtml(root.dataset.thankYou);
      content.innerHTML = `<div class="ls-wellness-quiz__thanks"><div class="ls-wellness-quiz__thanks-icon">◇</div><h3 class="ls-wellness-quiz__result-title">${title}</h3><p class="ls-wellness-quiz__result-copy">${escapeHtml(root.dataset.checkInbox)}</p><p class="ls-wellness-quiz__fine-print">${escapeHtml(root.dataset.matchedTo)} ${escapeHtml(profile.title)}</p></div>`;
    };

    const renderResult = () => {
      profileIndex = calculateProfile();
      const profile = config.results[profileIndex];
      renderProgress(true);
      content.innerHTML = `<div class="ls-wellness-quiz__result"><p class="ls-eyebrow">${escapeHtml(profile.eyebrow)}</p><h3 class="ls-wellness-quiz__result-title">${escapeHtml(profile.title)}</h3><p class="ls-wellness-quiz__result-copy">${escapeHtml(profile.profile)}</p><div class="ls-wellness-quiz__capture"><h3>${escapeHtml(root.dataset.captureHeading)}</h3><p>${escapeHtml(root.dataset.captureCopy)}</p><div class="ls-wellness-quiz__form"><label class="ls-visually-hidden" for="QuizName-${root.id}">${escapeHtml(root.dataset.nameLabel)}</label><input id="QuizName-${root.id}" type="text" autocomplete="given-name" placeholder="${escapeHtml(root.dataset.namePlaceholder)}"><label class="ls-visually-hidden" for="QuizEmail-${root.id}">${escapeHtml(root.dataset.emailLabel)}</label><input id="QuizEmail-${root.id}" type="email" autocomplete="email" placeholder="${escapeHtml(root.dataset.emailPlaceholder)}" required><button type="button" class="ls-button" data-submit>${escapeHtml(labels.submitLabel)}</button><p class="ls-wellness-quiz__error" data-error>${escapeHtml(root.dataset.error)}</p></div><p class="ls-wellness-quiz__fine-print">${escapeHtml(root.dataset.finePrint)}</p></div><a class="ls-wellness-quiz__browse" href="/collections/all">${escapeHtml(root.dataset.browse)}</a></div>`;
      content.querySelector('[data-submit]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const name = content.querySelector('input[type="text"]').value.trim();
        const emailInput = content.querySelector('input[type="email"]');
        const email = emailInput.value.trim();
        const error = content.querySelector('[data-error]');
        if (!emailInput.checkValidity()) {
          emailInput.reportValidity();
          return;
        }
        button.disabled = true;
        button.textContent = labels.sendingLabel;
        error.style.display = 'none';
        try {
          await sendToKlaviyo(name, email, profile);
          renderThankYou(name, profile);
        } catch (requestError) {
          button.disabled = false;
          button.textContent = labels.submitLabel;
          error.style.display = 'block';
        }
      });
    };

    root.querySelector('[data-ls-quiz-start]').addEventListener('click', (event) => {
      event.preventDefault();
      root.querySelector('.ls-wellness-quiz__card').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    renderQuestion();
  };

  const initAllWellnessQuizzes = () => document.querySelectorAll('[data-ls-wellness-quiz]').forEach(initWellnessQuiz);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllWellnessQuizzes);
  else initAllWellnessQuizzes();
  document.addEventListener('shopify:section:load', initAllWellnessQuizzes);

  } catch(e) { console.error(e); }
})();
})();
